import React from 'react';
import { XCircle } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function PainPoints() {
  const points = ['Buscás info técnica que nunca aplica exactamente a tu moto', 'Le pagás al mecánico sin entender si el precio es justo', 'Salís sin checklist ni diagnóstico antes de cada ruta', 'No tenés un registro organizado de mantenimiento', 'El mismo ciclo de dudas y gastos, cada fin de semana'];
  return <section className="py-24 relative overflow-hidden" data-id="element-178">
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-179">
        <FadeIn data-id="element-180">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-8" data-id="element-181">
            ¿Cuántos fines de semana más vas a salir{' '}
            <span className="text-red-500" data-id="element-182">sin estar preparado?</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-183">
          <p className="text-lg md:text-xl text-gray-300 text-center mb-12 leading-relaxed" data-id="element-184">
            Amás la moto. Pero nadie te dijo que ibas a pasar los domingos
            buscando en YouTube, pagando lo que te dice el mecánico sin poder
            cuestionar nada, y saliendo a la ruta con dudas que "se resuelven
            solas".
            <br data-id="element-185" />
            <br data-id="element-186" />
            <strong className="text-white" data-id="element-187">
              No es falta de pasión. Es falta de un sistema.
            </strong>
          </p>
        </FadeIn>

        <div className="bg-surface p-8 md:p-10 rounded-3xl border border-red-500/20 shadow-[0_0_30px_rgba(239,68,68,0.05)]" data-id="element-188">
          <ul className="space-y-6" data-id="element-189">
            {points.map((point, index) => <FadeIn key={index} delay={0.2 + index * 0.1} data-id="element-190">
                <li className="flex items-start gap-4" data-id="element-191">
                  <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-192" />
                  <span className="text-lg text-gray-300" data-id="element-193">{point}</span>
                </li>
              </FadeIn>)}
          </ul>
        </div>

        <FadeIn delay={0.8} data-id="element-194">
          <div className="mt-16 text-center" data-id="element-195">
            <p className="text-2xl md:text-3xl font-heading text-cyan" data-id="element-196">
              ¿Y si este fuera el último fin de semana que salís sin estar
              blindado?
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}